import React, { useEffect, useState } from "react";
import MarketDataCard from "./stock-data-card";
import { selectCategories, selectCategoriesComingSoon, setSelectedCategory } from "./stock-data-slice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { Tooltip } from "react-tooltip";

export interface MarketDataCategoryFilterProps {
}

const MarketDataCategoryFilter: React.FC<MarketDataCategoryFilterProps> = (props: MarketDataCategoryFilterProps) => {

  // React States
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedDivId, setSelectedDivId] = useState("");
  const [translateX, setTranslateX] = useState(0);
  const [translateY, setTranslateY] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  // Redux data
  const dispatch = useAppDispatch();
  const categories = useSelector(selectCategories);
  const categoriesComingSoon = useSelector(selectCategoriesComingSoon);

  // Calculate translate values, when selected category changes
  useEffect(() => {
    setWidth(document.getElementById(selectedDivId)?.offsetWidth ?? 0);
    setHeight(document.getElementById(selectedDivId)?.offsetHeight ?? 0);
    setTranslateX(document.getElementById(selectedDivId)?.offsetLeft ?? 0);
    setTranslateY(document.getElementById(selectedDivId)?.offsetTop ?? 0);
  }, [selectedDivId])

  // Force a calculation for translate values once for the first category, when category list changes
  useEffect(() => {
    if (categories.length > 0) {
      setSelectedDivId(categories[0] + "0");
    }
  }, [categories])

  const changeCategoryHandler = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) => {
    if (categoriesComingSoon.some(comingSoon => categories[index] === comingSoon)) {

    } else {
      dispatch(setSelectedCategory({ selected: categories[index] }));
      setSelectedIndex(index);
      setSelectedDivId(e.currentTarget.id);
    }
  }

  return (
    <div className='flex flex-col w-full items-center'>

      {/** Category list */}
      <div className="relative">
        <div className={`absolute left-0 top-0 border bg-slate-950/80 border-blue-100/30 shadow-md shadow-slate-900/80 rounded-lg transition-transform duration-300`}
          style={{
            width,
            height,
            transform: `translateX(${translateX}px) translateY(${translateY}px)`,
          }}>
        </div>
        <div className="relative flex flex-row w-full h-full">
          {categories.map((category, index) => {
            return (
              <div
                key={category + index.toString()}
                id={category + index.toString()}
                onClick={(e) => !categoriesComingSoon.some(comingSoon => category === comingSoon) && changeCategoryHandler(e, index)}
                className="cursor-pointer ml-2"
              >
                <div data-tooltip-id={category}>
                  <MarketDataCard selected={selectedIndex === index} marketData={category} />
                </div>
                {categoriesComingSoon.some(comingSoon => category === comingSoon) &&
                  <Tooltip place="bottom" id={category} style={{ backgroundColor: "rgba(0, 0, 0, 0.95)", zIndex: 50 }} >
                    <div className="flex flex-col items-center justify-center text-xs lg:text-sm font-semibold text-neutral-300">
                      <label>Em breve</label>
                    </div>
                  </Tooltip>
                }
              </div>
            )
          })}
        </div>
      </div>

    </div >
  )
}

export default MarketDataCategoryFilter;